import React, { Component } from 'react';
import { base, firebaseAuth, algoliaKey, alogoliaAccount, logComponentLoad } from '../../../config/constants';
import { Grid, Button } from 'semantic-ui-react'
import Select from 'react-select';
import { SingleDatePicker } from 'react-dates';
import * as UiConsts from '../../../config/UiConstants'
import OrderCard from '../../dashBoard/newDashboard/OrderCard';
import * as algoliasearch from 'algoliasearch';
import { getPrintValues, checkAdminEmail, getOrderByOrderNum } from '../../dashBoard/newDashboard/algoliaDashboard/AlgoliaMiscUtils';
import { getSalesPeople, getDeliveryGuys, getShirtTypesToDisplay } from '../../dashBoard/newDashboard/LargeProjects/ApiUtils'
import { getSalesPeopleDropDown, getDeliveryGuysDropdown } from '../../dashBoard/newDashboard/LargeProjects/LargeProjectUtils'



class QueryOrdersAlgolia extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // order: '',
            imageUrl: '',
            orderNumber: '',
            loadingUser: true,
            loading: false,
            orderFound: '',
            order: [],
            deliveryPeople: [],
            orderNotFound: false,
            status: '',
            designers: [],
            salesPeopleChoices: [],
            deliveryPersonChoices: [],

            numOrders:0,
            startDateSet: false,
            itemType:''
        }
    }


    componentDidMount() {
        firebaseAuth().onAuthStateChanged((user) => {

            if (user) {
                console.log("maddx241 user is:" + user.email);

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult);
                    getSalesPeople(this.loadSalesPeople);
                    getDeliveryGuys(this.loadDelGuys);
                    getShirtTypesToDisplay(this.setShirtTypeDropDown, "imageSearch");
                    //getOrderByOrderNum(this.props.match.params.order_num, this.setAlgoliaOrder)
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    loading: false,
                    user: user,
                    uid: user.uid
                })
            }
        });

    }


    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        logComponentLoad(returnObject, "QueryOrdersAlgolia");

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
            loadingUser: false
        })

        if (returnObject.isAdmin) {

            // this.loadOrders(this.props.match.params.order_num);

            this.loadDesigners();
            getPrintValues("statuses", this.loadStatuses);
            getPrintValues("adminemail", this.loadAdmins);
            // this.queryOrders();

        }
    }

    loadDelGuys = (delGuys) => {
        //  console.log("getDelguys ++++++++:loadSalesPeopleDropdown");
        //  console.log("getdelguys:"+JSON.stringify(delGuys,null,3));
        if (delGuys && delGuys.length > 0) {
            console.log("getdelguys customer dropdown...")
            this.setState({
                deliveryPersonChoices: getDeliveryGuysDropdown(delGuys)
            })
        } else {
            alert("unable to load delivery people")
        }
    }

    loadSalesPeople = (salesPeople) => {
        console.log("getSales2 ++++++++:loadSalesPeopleDropdown");
        //console.log("getSales22:"+JSON.stringify(salesPeople,null,3));
        if (salesPeople && salesPeople.length > 0) {
            console.log("getSales23 customer dropdown...")
            this.setState({
                salesPeopleChoices: getSalesPeopleDropDown(salesPeople)
            })
        } else {
            alert("unable to load salespeople")
        }
    }

    loadStatuses = (statuses) => {
        // console.log("ddx12 ++++++ loadStatuses ");
        // console.log("ddx121 statuses:"+JSON.stringify(statuses, null, 3));
        this.setState({ orderStatuses: statuses })
    }

    loadAdmins = (statuses) => {
        console.log("addx12 ++++++ admins ");
        // console.log("addx121 admins:" + JSON.stringify(statuses, null, 3));
        this.setState({ admins: statuses })
    }

    loadDesigners = () => {
        console.log("aglx922:-----: loadDesigners calling getDesigners");


        var client = algoliasearch(alogoliaAccount, algoliaKey);
        var index = client.initIndex('printb_values');

        index.search({
            query: '',
            //  facetQuery: '',
            filters: 'grouping:design'
        }).then(content => {
            //    console.log("aglx91:" + JSON.stringify(content.hits, null, 3));

            this.setState({
                designers: content.hits
            });


        }).catch(function (err) {
            console.log(err);
            console.log(err.debugData);

        });

    }

    setShirtTypeDropDown = (shirtTypes) => {
        // console.log("gshtx21 +++++++:setShirtTypeDropDown");
        // console.log("gshtx22:" + JSON.stringify(shirtTypes, null, 3));
        this.setState({
            loading: false,
            shirtTypeChoices: shirtTypes
        })
    }

    getQueryString = () => {

        let queryString = '';

        if(this.state.itemType != ''){
            
            queryString = "dateNum > " + this.state.start_dateNum + " AND dateNum < " + this.state.end_dateNum + " AND itemType:'"+this.state.itemType+"'";
            console.log("itemType is not null:"+queryString);
        }else{
            queryString = "dateNum > " + this.state.start_dateNum + " AND dateNum < " + this.state.end_dateNum ;
            console.log("itemType is null:"+queryString);
        }

        return queryString;
    }


    queryOrders = () => {
        console.log("artx2 +++++++++++: queryOrders");

        this.setState({loading:true})

        if (this.state.start_dateNum >= this.state.end_dateNum) {
            console.log("start date is after end date");
            alert("start date is after end date");

        } else {
            var client = algoliasearch(alogoliaAccount, algoliaKey);
            var index = client.initIndex('printboda_test');


            index.search({
                query: '',
                //  facetQuery: '',
                //filters: "dateNum > " + this.state.start_dateNum + " AND dateNum < " + this.state.end_dateNum + " AND itemType:'"+this.state.itemType+"'"
                filters: this.getQueryString()
            }).then(content => {
                console.log("artx20 return size:" + content.hits.length)
                console.log("artx22:" + JSON.stringify(content.hits, null, 3));

                this.setState({
                    order: content.hits,
                    numOrders: content.hits.length,
                    loading: false
                })

            }).catch(function (err) {
                console.log(err);
                console.log(err.debugData);
                this.setState({loading:true})

                return 'error'
            });
        }


    }

    dateSelectOnChange = (date) => {
        console.log("start ++++++++:dateSelectOnChange");
        console.log("start date:" + date);
        console.log("start date.getValue():" + date.valueOf());
        console.log("startDateSet:" + this.state.startDateSet);

        if (!this.state.startDateSet) {
            console.log("startdate is " + this.state.startDateSet);

            this.setState({
                start_date: date,
                start_dateNum: date.valueOf() - 43200000,
                start_dateString: date.format('dddd MMMM Do'),
                startDateSet: true
            })
        } else if (this.state.startDateSet) {
            console.log("startdate is " + this.state.startDateSet);

            this.setState({
                end_date: date,
                end_dateNum: date.valueOf() - 43200000,
                end_dateString: date.format('dddd MMMM Do'),
                startDateSet: false
            })
        }
    }

    handleDropDownChanges = (value) => {
        console.log("gshtx4 +++  handleDropDownChanges");
        console.log('gshtx41 You\'ve sss:', value);
        console.log('gshtx42 You\'ve selected:', value.value + " " + value.category+ " " + value.label);

        this.setState({
            itemType: value.label
        })

        // } else {
        // console.log("gshtx43 category is NOT shirtTypeId");
        // //this.setState(newState);
        // let newState = {};
        // newState[value.category] = value.value;
        // console.log("newState 1:" + JSON.stringify(newState, null, 3));

        // //this.setState(newState);
        // this.setState(newState);

    }

    render() {

        const searchButton = this.state.start_dateNum && this.state.end_dateNum
            ? <Button onClick={this.queryOrders}> SEARCH </Button>
            : ''

        const orderUI = this.state.order.map((order) =>
            <Grid.Column>
                <OrderCard
                    //user={this.state.userFromFirebaseNode}
                    searchNow={true}
                    user={this.state.user}
                    algoliaUser={this.state.algoliaUser}
                    order={order}
                    deliveryPeople={this.state.deliveryPeople}
                    designers={this.state.designers}
                    orderStatuses={this.state.orderStatuses}
                    salesPeopleChoices={this.state.salesPeopleChoices}
                    deliveryPersonChoices={this.state.deliveryPersonChoices} />
            </Grid.Column>
        )

        const loadingImage = this.state.loading === true
            ? <UiConsts.LoadingComponent />
            : <div>
                <Grid stackable columns={3}>
                    {orderUI}
                </Grid>

            </div>


        return (this.state.loading === true ? <UiConsts.LoadingComponent /> :
            <div>
                <h1>START DATE- {this.state.start_dateString} - {this.state.start_dateNum}</h1>
                <h1>END DATE - {this.state.end_dateString} - {this.state.end_dateNum}</h1>
                <h3>NUM ORDERS: -{this.state.numOrders}</h3>
                <h3>ITEM TYPE: -{this.state.itemType}</h3>

                <SingleDatePicker
                    date={this.state.date} // momentPropTypes.momentObj or null
                    //onDateChange={date => this.setState({ date })} // PropTypes.func.isRequired
                    onDateChange={date => this.dateSelectOnChange(date)} // PropTypes.func.isRequired
                    focused={this.state.focused} // PropTypes.bool
                    isOutsideRange={() => false}
                    onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                />

                <br />
                <Select
                    name="form-field-name"
                    // value={this.state.shirtType}
                    value={this.state.shirtTypeId}
                    options={this.state.shirtTypeChoices}
                    onChange={this.handleDropDownChanges}
                    searchable={true}
                    clearable={false}
                />
                <br />
                {searchButton}

                {loadingImage}
                {/* <h2>imageUrls:{this.state.imageUrl}</h2> */}

            </div>
        )
    }
}

export default QueryOrdersAlgolia;


// WEBPACK FOOTER //
// ./src/components/newSite/algolia/QueryOrdersAlgolia.js